/**************************************************
 * Nombre:       Dialogo_Detalle_Producto_Comanda
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo_redondo.svg'
import {Delete} from "@mui/icons-material";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import Formulario_Producto_Comanda_Editar from "../Formularios/Formulario_Producto_Comanda_Editar";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";
import {guardarDocs} from "../../Servicios/BD/guardarDocs";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";

const Dialogo_Detalle_Producto_Comanda = ({datos, cerrar, realizado}) => {
    const {props: props_, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })


    const guardarCambios = async () => {


        let entidad = await obtenerEntidad()
        iniciarCarga('Guardando Cambios...')
        await guardarDoc('platosPedidos', entidad)
        realizado()
        cerrar()

    }

    const borrar = async () => {

        iniciarCarga('Borrando Plato...')
        await borrarDoc('platosPedidos', datos.id)
        terminar({aviso: 'Plato Borrado'})
        realizado()
        cerrar()

    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Formulario_Producto_Comanda_Editar props={props_}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => guardarCambios()}
                >Guardar Datos</Button>
            </Grid>

            {datos && datos.id &&
                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid>
            }


        </Grid>
    )

}
export default Dialogo_Detalle_Producto_Comanda